// the bridge uses jotai for state
// https://github.com/pmndrs/jotai

import { MessageStatus } from '../constants/messageStatus';
import { atomWithStorage } from 'jotai/utils';
import { Address } from 'viem';
import { NetworkChainIds } from '@dapp/multi-lib/network';
import { BridgeToken } from '../constants/bridgeTokens';
import { TFailedMessage } from '../constants/types';

export type TTransaction = {
  status: MessageStatus;
  userAddress: Address;
  srcChainId: NetworkChainIds;
  dstChainId: NetworkChainIds;
  toAddress: string;
  srcTxHash: `0x${string}`;
  dstTxHash: `0x${string}`;
  amount: string;
  minAmount: string;
  nativeFee: string;
  failedMessage?: TFailedMessage;
  token: BridgeToken;
  initialNonce: string;
};

export const transactionsAtom = atomWithStorage<TTransaction[]>(
  'sdao.transactions',
  [],
  {
    getItem(key, initialValue) {
      const storedValue = localStorage.getItem(key);
      try {
        return storedValue ? JSON.parse(storedValue) : initialValue;
      } catch (error) {
        console.error('Error parsing transactions from localStorage:', error);
        return initialValue;
      }
    },
    setItem(key, value) {
      localStorage.setItem(key, JSON.stringify(value));
    },
    removeItem(key) {
      localStorage.removeItem(key);
    },
  }
);
